<template>
  <div class="container">
    <v-row class="justify-center mb-10">
      <h2 id="whole-genome-sequencing-test-title">
        Select test type:
      </h2>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="auto" class="d-flex justify-center">
        <v-btn
          id="prenatal-button"
          @click="isPrenatal = true"
          :class="
            isPrenatal
              ? 'primary-btn btn-padding-medium'
              : 'secondary-btn btn-padding-medium'
          "
        >
          Prenatal
        </v-btn>
        <v-btn
          id="postnatal-button"
          @click="isPrenatal = false"
          :class="
            isPrenatal === false
              ? 'primary-btn btn-padding-medium ml-3 ml-md-10'
              : 'secondary-btn btn-padding-medium ml-3 ml-md-10'
          "
        >
          Postnatal
        </v-btn>
      </v-col>
    </v-row>
    <div class="container" v-if="isPrenatal !== null">
      <v-row class="justify-center mb-2" v-if="isPrenatal">
        <p class="heading-grey heading-small">
          Testing for a current, ongoing pregnancy.
        </p>
      </v-row>
      <v-row class="justify-center top-bottom-margin">
        <p class="heading-grey heading-medium">
          {{ isPrenatal ? "Prenatal" : "Postnatal" }} tests include:
        </p>
      </v-row>
      <v-row class="justify-center">
        <v-col
          v-if="isPrenatal === false"
          cols="4"
          class="text-start custom-col"
        >
          <ul
            class="dot-points mb-3"
            v-for="test in availableTestsFirstCol"
            :key="test.name"
          >
            <li>{{ test }}</li>
          </ul>
        </v-col>
        <v-col
          v-if="isPrenatal === false"
          cols="4"
          class="text-start custom-col"
        >
          <ul
            class="dot-points mb-3"
            v-for="test in availableTestsSecondCol"
            :key="test.name"
          >
            <li>{{ test }}</li>
          </ul>
        </v-col>
        <v-col
          v-if="isPrenatal === false"
          cols="4"
          class="text-start custom-col"
        >
          <ul
            class="dot-points mb-3"
            v-for="test in availableTestsThirdCol"
            :key="test.name"
          >
            <li>{{ test }}</li>
          </ul>
        </v-col>
        <v-col v-if="isPrenatal" cols="12" class="text-center">
          <div style="display: inline-block; text-align: left;">
            <ul
              class="dot-points mb-3 text-start"
              v-for="test in availableTestsLeftCol"
              :key="test.name"
            >
              <li>{{ test }}</li>
            </ul>
          </div>
        </v-col>
      </v-row>
      <v-row class="justify-center mt-12">
        <p class="heading ">
          For any enquiries, please contact the team at
          <a v-bind:href="'mailto:VCGSgenomics@vcgs.org.au'"
            >VCGSgenomics@vcgs.org.au</a
          >
          or call <a v-bind:href="'tel:03 9340 9102'">(03) 9340 9102</a>.
        </p>
      </v-row>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../event-bus";
import { useSectionStore } from "../store/SectionStore";
export default {
  data() {
    return {
      isPrenatal: null,
      availableTestsFirstCol: [],
      availableTestsSecondCol: [],
      availableTestsThirdCol: [],
      state: {},
      currentTests: {},
    };
  },
  watch: {
    isPrenatal() {
      const store = useSectionStore();
      store.isPrenatal = this.isPrenatal;
      this.getLists();
      EventBus.$emit("resetFormWizard"); //Reset wizard so client has to click through steps sequentially
      EventBus.$emit("resetSampleType"); //reset sample type to ""
      EventBus.$emit("removeTests", store); //remove all chosen tests from billing and state
      EventBus.$emit("clearSelectedTests"); // Clear selectedTests array in Tests component
      EventBus.$emit("clearSelectedCategories"); // Clear selectedCategories array in TestSelection component
    },
  },

  methods: {
    removeTests() {
      EventBus.$emit("removeTests", store.AddedOrderofPanels);
    },
    //get tests with/without 'prenatal' in their category list and sort these tests into two lists
    getLists() {
      const state = useSectionStore();
      let tests;
      if (this.isPrenatal) {
        tests = Object.values(state.showTests)
          .filter((test) => {
            return test.category.some((item) => item.includes("prenatal"));
          })
          .map((test) => test.testName)
          .sort();
        this.availableTestsLeftCol = tests;
      } else {
        tests = Object.values(state.showTests)
          .filter((test) => {
            return test.category.some((item) => !item.includes("prenatal"));
          })
          .map((test) => test.testName)
          .sort();
      }
      const thirdTests = Math.ceil(tests.length / 3);
      this.availableTestsFirstCol = tests.slice(0, thirdTests);
      this.availableTestsSecondCol = tests.slice(thirdTests, 2 * thirdTests);
      this.availableTestsThirdCol = tests.slice(2 * thirdTests);
    },
  },
};
</script>

<style scoped>
.container {
  margin-top: 30px;
}

.justify-center {
  justify-content: center;
  text-align: center;
}
.dot-points {
  list-style-type: disc !important;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-size: 18px;
  line-height: 32px;
  margin-left: 20px; /* Optional: To give some space for the dot points */
}

.dot-points li::marker {
  color: #00538b;
}
.heading-grey {
  color: #737373;
  font-family: "Nunito", sans-serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 30px;
}

.heading-medium {
  font-weight: 400;
  font-size: 24px;
  line-height: 30px;
}

.heading-small {
  color: #000000 !important;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}
</style>
